import {FC, ReactNode} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'
import {ModalCloseButton, ModalHeader} from '@components/ui/modal-atoms'
import {Dialog, DialogClose, DialogContent} from '@components/ui/dialog'
import {usePhotosUpload} from '@features/photos-upload/store.ts'
import {cn} from '@utilities/helpers'

export const PhotosUploadModalWrapper: FC<{className?: string; children: ReactNode}> = ({children, className}) => {
    const {t} = useTranslation()
    const step = usePhotosUpload(store => store.step)
    const setIsOpen = usePhotosUpload(store => store.setIsOpen)

    return (
        <Dialog open={true} onOpenChange={() => setIsOpen(false)}>
            <DialogContent
                className={cn('w-180 grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden', className)}
                showCloseButton={false}
            >
                <ModalHeader className="relative py-[18px] px-6 text-center text-sm font-bold [&>button]:absolute [&>button]:top-2.5 [&>button]:left-2">
                    <DialogClose data-slot="dialog-close" render={<ModalCloseButton disabled={step == 'upload'} />} />
                    {t('single_shooting:upload_raw_photos')}
                </ModalHeader>
                {children}
            </DialogContent>
        </Dialog>
    )
}
